import { Link } from "@tanstack/react-router";
import { getAuthor } from "@/lib/authors";
import { Check, Pencil } from "lucide-react";

type Person = NonNullable<ReturnType<typeof getAuthor>>;

function Chip({ person, role, kind }: { person: Person; role: string; kind: "author" | "reviewer" }) {
  return (
    <Link to="/auteurs/$slug/" params={{ slug: person.slug }} className="flex min-w-0 items-center gap-2">
      <span className="relative shrink-0">
        <img src={person.photo} alt={person.name} loading="eager" width={28} height={28} decoding="async" className="h-7 w-7 rounded-full border border-border object-cover" />
        <span className={`absolute -bottom-0.5 -left-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border border-background ${kind === "author" ? "bg-primary text-primary-foreground" : "bg-success text-success-foreground"}`}>
          {kind === "author" ? <Pencil className="h-2 w-2" aria-hidden /> : <Check className="h-2 w-2" aria-hidden />}
        </span>
      </span>
      <span className="min-w-0 leading-tight">
        <span className="block truncate text-[13px] font-semibold sm:text-sm text-foreground">{person.name}</span>
        <span className="block truncate text-[11px] text-muted-foreground sm:text-xs">{role}</span>
      </span>
    </Link>
  );
}

/** Betsquare-stijl: H1 → auteur + factchecker naast elkaar → vetgedrukte datum → intro. */
export function AuthorByline({
  authorSlug,
  reviewerSlug,
  updatedAt,
}: {
  authorSlug: string;
  reviewerSlug?: string;
  updatedAt: string;
  readingMinutes?: number;
}) {
  const author = getAuthor(authorSlug);
  const reviewer = reviewerSlug ? getAuthor(reviewerSlug) : null;
  if (!author) return null;

  return (
    <div>
      <div className="mt-2.5 grid max-w-md grid-cols-2 gap-2 sm:mt-3 sm:gap-3">
        <Chip person={author} role={author.role ?? "Auteur"} kind="author" />
        {reviewer ? <Chip person={reviewer} role="Factchecker" kind="reviewer" /> : null}
      </div>
      <p className="mt-2 text-xs font-semibold text-foreground sm:text-sm">Laatst geüpdatet: {updatedAt}</p>
    </div>
  );
}
